import DefaultEntityCrud from 'components/form/DefaultEntityCrud'
import FormContent from 'components/form/FormContent'
import FormRow from 'components/form/FormRow'
import SelectInput from 'components/form/input/SelectInput'
import TextInput from 'components/form/input/TextInput'
// import getGruposPermissao from 'entity/GrupoPermissao'
import User from 'entity/User'
// import firebaseUtil from 'firebaseUtil'
// import useNotification from 'notification'
import React from 'react'
// import { useNavigate } from 'react-router-dom'
import SelectGrupoPermissao from '../SelectGrupoPermissao'
import { DebugFormConsole } from './functions'
import SeletorCliente from 'entity/Cliente/components/SeletorCliente'
import { useFieldValue } from 'components/form/input/NestedField'
import PainelClientesPerfil from '../PainelClientesPerfil'

function UserFormInter(props) {
    const { values } = props
    const grupoPermissao = values.grupoPermissao ? values.grupoPermissao.nome : ''
    const [uid] = useFieldValue("uid")

    return (
        <FormContent sx={{ p: 2 }}>
            <FormRow>
                <DebugFormConsole values={values} />
            </FormRow>
            <FormRow sx={{ gap: 3 }}>
                <SelectInput
                    sx={{ flex: 0.2 }}
                    name="status"
                    label="Status"
                    options={["ATIVO", "INATIVO"]}
                    required
                />
                {/* <TextInput name="nome" label="Nome" required sx={{ flex: 1 }} />
                <TextInput name="email" label="E-mail" required /> */}

                <TextInput name="nome" label="Nome" required />
                <TextInput type="email" name="email" label="E-mail" required />
            </FormRow>
            <FormRow sx={{ gap: 3 }} >
                <TextInput name="telefone" label="Telefone" sx={{ flex: 0.5 }} />
                <SelectGrupoPermissao sx={{ flex: 0.5 }} required />
            </FormRow>
            {
                grupoPermissao === "Líder" &&
                <>
                    <FormRow>
                        <PainelClientesPerfil uidUser={uid} hideScrollbar={true} />
                    </FormRow>
                </>
            }

        </FormContent>)
}

export default function UserForm() {

    // const navigate = useNavigate();
    // const { showWarning, showError } = useNotification();

    // const validValues = (values) => {
    //     if (values.senha !== values.confirmarSenha) {
    //         showWarning("As senhas estão diferentes");
    //         return false;
    //     }

    //     if (values.email) {
    //         let isEmailValid = String(values.email)
    //             .toLowerCase()
    //             .match(
    //                 /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    //             );
    //         if (!isEmailValid) {
    //             showWarning("Email inválido");
    //             return false;
    //         }
    //     }

    //     return true;
    // };

    // const saveValues = (values) => {
    //     // console.log('saveValues', values)

    //     firebaseUtil
    //         .registerNoLogin(values.email, values.senha)
    //         .then((user) => {
    //             console.log('user', user)

    //             let usuario = new User();

    //             usuario.update({
    //                 uid: user.user.uid,
    //                 name: values.name,
    //                 email: values.email,
    //                 telefone: values.telefone,
    //                 senha: values.senha,
    //                 status: values.status,
    //                 grupoPermissao: values.grupoPermissao
    //             });

    //             usuario.save().then(() => {
    //                 navigate("/_usuario?uid=" + user.user.uid);
    //             });
    //         })
    //         .catch((error) => {
    //             // console.log("error", error)

    //             switch (error.code) {
    //                 case "auth/invalid-email":
    //                     showError("Endereço de e-mail Inválido");
    //                     break;
    //                 case "auth/email-already-in-use":
    //                     showError("Endereço de e-mail já em uso");
    //                     break;
    //                 case "auth/weak-password":
    //                     showError("Senha muito fraca");
    //                     break;
    //                 // case 'auth/user-disabled':
    //                 //     showError('O usuário pode ter sido desativado')
    //                 //     break;
    //                 // case 'auth/user-not-found':
    //                 //     showError('Não há registro de usuário correspondente a esse identificador. O usuário pode ter sido excluído')
    //                 //     break;
    //                 // case 'auth/wrong-password':
    //                 //     showError('Senha inválida ou o usuário não tem uma senha')
    //                 //     break;
    //                 default:
    //                     break;
    //             }
    //         });
    // };

    return (
        <DefaultEntityCrud
            title={"Cadastro/atualização de Usuário"}
            EntityClass={User}
            routeForm={"_usuario"}
            backRoute="consulta-usuario"
            // saveValues={saveValues}
            // validValues={validValues}

            formActions={{ novoForm: false, salvarForm: true, sairForm: true }}
        >
            {(props) => <UserFormInter {...props} />}
        </DefaultEntityCrud>
    )
}
